<template>
  <QCard flat class="bg-grey-1">
    <QCardSection>
      <span>On behalf of {{ employerName }}, I confirm that:</span>
      <ul class="q-mb-none q-mt-sm q-pl-lg">
        <li>
          <span>
            the person whose details appear in the Quote is an employee of
            {{ employerName }} and their address and salary details provided are
            correct; and
          </span>
        </li>
        <li>
          <span>
            I have authority to approve the Quote and agree to enter into the
            <strong>Novation Agreement</strong> in relation to the employee’s
            lease.
          </span>
        </li>
      </ul>
    </QCardSection>
  </QCard>
</template>

<script>
import { QCard, QCardSection } from 'quasar';

export default {
  name: 'HRApprovalTerms',
  props: {
    employerName: String
  },
  components: {
    QCard,
    QCardSection
  }
};
</script>
